import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
 getPatientMonitorings () {
   return Api().get("/patient-monitorings");
},
  updatePatientMonitoring (params) {
    return Api().put("/patient-monitorings",params);
  },
  addPatientMonitoring (params) {
    return Api().post("/patient-monitorings",params);
  },
  getPatientMonitoring (params) {
    return Api().get("/patient-monitorings/"+params);
  },
  getPatientMonitoringByRouteSheetForm (params) {
    return Api().post("/patient-monitorings-by-id-form",params);
  },
  deletePatientMonitoring (params) {
    return Api().delete("/patient-monitorings/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/PatientMonitoringService.js